import {
  ItemRenderExtensionOptions,
  createItemRenderExtension,
  createItemRenderExtensions,
  useItemRenderExtensions,
} from '@spotify/confidence-core-react';
import {
  ActivityFragment,
  ChangeSetFragment,
} from '@spotify/confidence-graphql';

export interface ActivityChangeOptions {
  activity: ActivityFragment;
  change: ChangeSetFragment['changes'][number];
}

export interface ActivityChangeExtensionOptions
  extends ItemRenderExtensionOptions<ActivityChangeOptions> {
  title?: (change: ChangeSetFragment['changes'][number]) => string;
}

export const createActivityChangeExtensions = (id: string) => {
  return createItemRenderExtensions({
    id,
  });
};

/**
 * Hook to retrieve all registered flag change item extensions.
 *
 * @returns a list of flag change item extensions
 */
export const useActivityChangeExtensions = (
  extensions: ReturnType<typeof createActivityChangeExtensions>,
): ActivityChangeExtensionOptions[] => {
  return useItemRenderExtensions<ActivityChangeExtensionOptions>(extensions);
};

/**
 * Create a flag change extension renderer.
 *
 * @param options - options for the extension
 * @param options.id - unique identifier for the extension
 * @param options.predicate - predicate to determine if the extension should be
 *   used for the given change
 * @param options.render - function to render the change item
 * @returns a Backstage extension
 */
export const createActivityChangeExtension = (
  options: ActivityChangeExtensionOptions,
) => {
  return createItemRenderExtension<ActivityChangeExtensionOptions>(options);
};
